/** Labels shown in the Skills section 3D tag sphere (order is arbitrary). */
export const SKILL_TAG_CLOUD_TEXTS = [
  'React',
  'Angular',
  'React Native',
  'Next.js',
  'Node.js',
  'TypeScript',
  'LangChain',
  'LangGraph',
  'OpenAI',
  'LLMs',
  'JavaScript',
  'Redux',
  'MobX',
  'RxJS',
  'Microfrontends',
  'GraphQL',
  'Kafka',
  'PostgreSQL',
  'MongoDB',
  'Redis',
  'Docker',
  'AWS',
  'Azure DevOps',
  'Jest',
  'Cypress',
  'Playwright',
  'Tailwind',
  'Prompt Engineering',
];
